import { render, staticRenderFns } from "./AddIcon2.vue?vue&type=template&id=1153c700"
import script from "./AddIcon2.vue?vue&type=script&lang=ts"
export * from "./AddIcon2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports